import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import "./BlogDetail.css";

const BlogDetail = () => {
  const { id } = useParams();

  const [blog, setBlog] = useState(null);
  const [allBlogs, setAllBlogs] = useState([]);
  const [readingTime, setReadingTime] = useState(0);
  const [darkMode, setDarkMode] = useState(false);

  // 🔥 Pagination state
  const [page, setPage] = useState(1);
  const blogsPerPage = 5;

  // Load dark mode
  useEffect(() => {
    const saved = localStorage.getItem("darkMode");
    if (saved === "true") setDarkMode(true);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // Fetch data
  useEffect(() => {
    axios.get(`https://alrimal.net/blogs/${id}`)
      .then(res => {
        setBlog(res.data);

        const words = res.data.content
          .replace(/<[^>]*>/g, "")
          .split(" ").length;

        setReadingTime(Math.ceil(words / 200));
      });

    axios.get("https://alrimal.net/blogs")
      .then(res => setAllBlogs(res.data));

    window.scrollTo(0, 0);
  }, [id]);

  if (!blog) return <p className="loading">Loading...</p>;

  // 🔥 Related blogs (exclude current)
  const relatedBlogs = allBlogs.filter(b => b.id !== blog.id);

  // 🔥 Pagination logic
  const indexOfLast = page * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;
  const currentBlogs = relatedBlogs.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(relatedBlogs.length / blogsPerPage);

  const shareUrl = window.location.href;

  return (
    <div className="blogPageWrapper">

      {/* Dark mode */}
      <button
        className="darkToggle"
        onClick={() => setDarkMode(!darkMode)}
      >
        {darkMode ? "☀️" : "🌙"}
      </button>

      <div className="blogLayout">

        {/* MAIN */}
        <div className="blogMain">

          <h1 className="blogTitle">{blog.title}</h1>

          <p className="blogMeta">
            {blog.date} • {readingTime} min read
          </p>

          <div className="blogImageWrapper">
            <img src={blog.image} alt="" className="blogImage" />
          </div>

          <div
            className="blogContent"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />

        </div>

        {/* SIDEBAR */}
        <div className="blogSidebar">

          {/* SHARE */}
          <div className="sidebarBox">
            <h4>Share</h4>

            <a
              href={`https://wa.me/?text=${shareUrl}`}
              target="_blank"
              rel="noreferrer"
              className="shareBtn whatsapp"
            >
              WhatsApp
            </a>

            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
              target="_blank"
              rel="noreferrer"
              className="shareBtn linkedin"
            >
              LinkedIn
            </a>
          </div>

          {/* 🔥 RELATED BLOGS */}
          <div className="sidebarBox">
            <h4>Related Blogs</h4>

            <div className="relatedList">
              {currentBlogs.map((item) => (
                <Link
                  key={item.id}
                  to={`/blog/${item.id}`}
                  className="relatedCard"
                >
                  <img
                    src={item.image}
                    alt=""
                    className="relatedImage"
                  />

                  <div className="relatedText">
                    <p className="relatedTitle">{item.title}</p>
                  </div>
                </Link>
              ))}
            </div>

            {/* 🔥 PAGINATION */}
            <div className="pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Prev
              </button>

              <span>{page} / {totalPages}</span>

              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>
            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default BlogDetail;